<template>
  <article class="article">
    <div class="article__wrapper grid">
      <h3 class="article__title brand-font_500">How this site works</h3>
      <p class="article__description">
        We think it's important you understand the strengths and limitations of the site. We're a
        journalistic website and aim to provide the best MoneySaving guides, tips, tools and
        techniques, but can't guarantee to be perfect, so do note you use the information at your
        own risk and we can't accept liability if things go wrong.
      </p>
      <ul class="article__list">
        <li class="article__point">
          This info does not constitute financial advice, always do your own research on top to
          ensure it's right for your specific circumstances and remember we focus on rates not
          service.
        </li>
        <li class="article__point">
          We don't as a general policy investigate the solvency of companies mentioned (how likely
          they are to go bust), but there is a risk any company can struggle and it's rarely made
          public until it's too late (see the
          <a
            href="https://tunirexun.com/shopping/section75-protect-your-purchases"
            class="article__link"
            target="_blank"
            rel="noopener"
            >Section 75</a
          >
          guide for protection tips).
        </li>
        <li class="article__point">
          Always remember anyone can post on the MSE forums, so it can be very different from our
          opinion.
        </li>
        <li class="article__point">
          We often link to other websites, but we can't be responsible for their content.
        </li>
      </ul>
      <p class="article__description">
        MoneySavingExpert.com is part of the MoneySupermarket Group, but is entirely editorially
        independent. Its stance of putting consumers first is protected and enshrined in the
        legally-binding
        <a
          href="https://tunirexun.com/site/editorial-code"
          class="article__link"
          target="_blank"
          rel="noopener"
          >MSE Editorial Code.</a
        >
      </p>
      <p class="article__description">
        MoneySavingExpert.com Limited is an appointed representative of MONY Group Financial
        Limited, which is authorised and regulated by the Financial Conduct Authority (FCA FRN
        303190). MONY Group Financial Limited, registered in England No. 3157344. Registered Office:
        MONY Group House, St. David's Park, Ewloe, CH5 3UZ.
      </p>
    </div>
  </article>
</template>

<style scoped lang="scss">
  .article {
    a {
      text-decoration: underline;
      font-weight: bold;
    }

    display: flex;
    justify-content: center;
    font-size: remc(14px);
    line-height: remc(22px);
    background: $white-3;
    box-shadow: inset 0 1px 4px $black-rgb-15;

    @include lg {
      padding: 28px 30px;
    }

    &__wrapper {
      max-width: $max-static-content-width;
    }

    &__list {
      display: grid;
      grid-template-columns: 1fr 1fr;
      grid-gap: 24px;

      @include md {
        grid-template-columns: 1fr;
      }
    }

    &__point {
      position: relative;
      padding-left: 14px;

      &::before {
        position: absolute;
        top: 10px;
        left: 0;
        display: block;
        width: 5px;
        height: 5px;
        content: '';
        background: $gray-1;
        border-radius: 100%;
      }
    }
  }
</style>
